export const GET_DASHBOARD_RTO_TOP_DATA="GET_DASHBOARD_RTO_TOP_DATA"
export const GET_DASHBOARD_RTO_TOP_CITY_DATA="GET_DASHBOARD_RTO_TOP_CITY_DATA"
export const GET_DASHBOARD_RTO_COUNT_MONTH_DATA="GET_DASHBOARD_RTO_COUNT_MONTH_DATA"
export const GET_DASHBOARD_RTO_TOP_COURIER_DATA="GET_DASHBOARD_RTO_TOP_COURIER_DATA"
export const GET_DASHBOARD_RTO_STATUS_DATA="GET_DASHBOARD_RTO_STATUS_DATA"

